module.exports = __webpack_public_path__ + "static/forus-f8612fa6db8e6acc3c122ead33583d96.png";